import { Grid } from "@mui/material";
import { NumberInput, SelectInput, required } from "react-admin";
import { DoctoralSchoolFeeCategoryChoices } from "utils/choices";

const SaveForm = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <NumberInput
        source="year"
        label="Година"
        min={2000}
        step={1}
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <SelectInput
        source="category"
        label="Категория"
        choices={DoctoralSchoolFeeCategoryChoices}
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <NumberInput
        source="amount"
        label="Такса"
        min={0}
        step={0.01}
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
  </Grid>
);

export default SaveForm;
